import React from 'react';
import { cn } from './cn.js';

const variants = {
  default: 'bg-ptcm-panel text-ptcm-ink dark:bg-gray-800 dark:text-gray-100',
  success: 'bg-ptcm-mint text-ptcm-ink dark:bg-green-900/40 dark:text-green-100',
  outline: 'border border-ptcm-border text-ptcm-ink dark:border-gray-700 dark:text-gray-100'
};

export default function Badge({ className, variant = 'default', ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold tracking-[0.04em]',
        variants[variant],
        className
      )}
      {...props}
    />
  );
}

